export default __webpack_public_path__ + "static/media/DEBoK_Brain_and_Words.1e359396.png";